import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import SocialLink from "../atoms/SocialLink.vue";
import githubLogo from "@/assets/logos/github.png";
import itchLogo from "@/assets/logos/itch.png";
import linkedinLogo from "@/assets/logos/linkedin.png";
import mailLogo from "@/assets/logos/mail.png";
import soundcloudLogo from "@/assets/logos/soundcloud.png";
import mastodonLogo from "@/assets/logos/mastodon.png";
import youtubeLogo from "@/assets/logos/youtube.png";
import blueSkyLogo from "@/assets/logos/bluesky.png";
import { Motion } from "motion/vue";
import { useInstruments } from "@/utils/conductor";
import { useI18n } from "vue-i18n";

interface SocialItem {
  key: string;
  logo: string;
  url: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

const items: SocialItem[] = [
  {
    key: "github",
    logo: githubLogo,
    url: "https://github.com/ClementRivaille",
  },
  {
    key: "itch",
    logo: itchLogo,
    url: "https://itooh.itch.io/",
  },
  {
    key: "youtube",
    logo: youtubeLogo,
    url: "https://www.youtube.com/@itooh-gamedev",
  },
  {
    key: "bluesky",
    logo: blueSkyLogo,
    url: "https://bsky.app/profile/itooh.bsky.social",
  },
  {
    key: "mastodon",
    logo: mastodonLogo,
    url: "https://ludosphere.fr/@Itooh",
  },
  {
    key: "linkedin",
    logo: linkedinLogo,
    url: "https://www.linkedin.com/in/cl%C3%A9ment-rivaille-39424b51/",
  },
  {
    key: "soundcloud",
    logo: soundcloudLogo,
    url: "https://soundcloud.com/itooh-web",
  },
];

const instruments = useInstruments();
const playNote = () => {
  if (instruments) {
    instruments.playSynth();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Motion), {
    animate: { opacity: 1 },
    initial: { opacity: 0 },
    transition: { duration: 0.5, delay: 0.5 },
    class: "flex md:flex-col gap-4 md:gap-6 items-center justify-center"
  }, {
    default: _withCtx(() => [
      _createVNode(SocialLink, {
        img: _unref(mailLogo),
        href: "mailto:elucubrations.itooh@gmail.com",
        onMouseover: playNote,
        onFocus: playNote,
        "aria-label": _unref(t)('about.links.mail')
      }, null, 8, ["img", "aria-label"]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
        return _createVNode(SocialLink, {
          img: item.logo,
          href: item.url,
          target: "_blank",
          key: item.key,
          onMouseover: playNote,
          onFocus: playNote,
          "aria-label": _unref(t)(`about.links.${item.key}`)
        }, null, 8, ["img", "href", "aria-label"])
      }), 64))
    ]),
    _: 1
  }, 8, ["transition"]))
}
}

})